import React, { useEffect, useState } from "react";
import SideMenuTile from "./SideMenuTile";
import { useDispatch, useSelector } from "react-redux";
import CreateGroupModel from "./CreateGroupModel";
import { GET_BOOKING_GROUPS, SET_THREAD_COUNTER } from "../../../../redux/constants";

const Sidebar = ({ activeGroup, setActiveGroup, activeGroupRef, setPage, hasMoreRef  }) => {
  const dispatch = useDispatch();
  const [modalOpen, setModelOpen] = useState(false);
  const { performancedata, subGroup, threadCounter } = useSelector((state) => state.todoPerformance);
  
  useEffect(() => {
    let markReadGroup = subGroup.findIndex(
      (item) => item.sub_group_id === activeGroup.sub_group_id
    );

    if(markReadGroup !== -1){
      subGroup[markReadGroup]["is_read"] = "";
      if(threadCounter > 0) dispatch({type: SET_THREAD_COUNTER, payload: threadCounter - 1 });
    }
    dispatch({
      type: GET_BOOKING_GROUPS,
      payload: subGroup,
    });

    activeGroupRef.current = activeGroup;

  }, [activeGroup]);

  return (
    <div className="h-full xxs:w-60 md:w-72 lg:w-80 bg-white shrink-0 pt-3 pr-4">
      <div>
        <div className="font-bold font-inter text-base text-[#1E293B]">
          Chats
        </div>
        <div className="w-full py-6">
          <button
            onClick={(e) => {
              e.preventDefault();
              setModelOpen(true);
            }}
            className="btn-sm !w-full !bg-white border !border-slate-200 hover:!border-slate-300 font-inter font-medium text-sm text-[#1E293B]"
          >
            Start A New Chat
          </button>
        </div>
      </div>
      <div
        className="h-full overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100"
        style={{ maxHeight: "calc(100vh - 270px)" }}
      >
        {subGroup.length > 0 && subGroup.map((item) => (
          <SideMenuTile
            group={item} 
            name={item.group_name}
            message={item?.message || ""}
            activeGroup={activeGroup}
            setActiveGroup={setActiveGroup}
            setPage={setPage}
            hasMoreRef={hasMoreRef} 
          />
        ))}
      </div>
      <CreateGroupModel
        modalOpen={modalOpen}
        setModelOpen={setModelOpen}
        activity_assignment_id={performancedata.activity_assignment_id}
      />
    </div>
  );
};

export default Sidebar;
